'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ProviderIntent = require('../components/ProviderIntent.js');

var _ProviderIntent2 = _interopRequireDefault(_ProviderIntent);

var _consts = require('../consts.js');

var _providerEvents = require('wix-art-store-3rd-party/dist/src/sdk/providerEvents');

var _providerEvents2 = _interopRequireDefault(_providerEvents);

var _WixSDKProviderApi = require('../components/WixSDKProviderApi');

var _WixSDKProviderApi2 = _interopRequireDefault(_WixSDKProviderApi);

var _wixSdkOOI = require('../gallery/wixSdkOOI');

var _wixSdkOOI2 = _interopRequireDefault(_wixSdkOOI);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThankyouIntentOOI = function (_Component) {
  (0, _inherits3.default)(ThankyouIntentOOI, _Component);

  function ThankyouIntentOOI(props) {
    (0, _classCallCheck3.default)(this, ThankyouIntentOOI);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ThankyouIntentOOI.__proto__ || (0, _getPrototypeOf2.default)(ThankyouIntentOOI)).call(this, props));

    _this.state = {
      height: null
    };
    return _this;
  }

  (0, _createClass3.default)(ThankyouIntentOOI, [{
    key: 'handleThankyouMessageReceived',
    value: function handleThankyouMessageReceived(type, payload, resolve, reject) {
      var storeApi = this.props.storeApi;

      switch (type) {
        case _providerEvents2.default.setHeight:
          this.setState({ height: payload.height });
          break;
        case _providerEvents2.default.clearCart:
          storeApi.clearCart();
          break;
        case _providerEvents2.default.backHome:
          storeApi.backHome();
          break;
        default:
          break;
      }
    }
  }, {
    key: 'init',
    value: function init() {
      this.props.tryToReportAppLoaded();
      if (!this.wixSdk) {
        var _props = this.props,
            baseUrl = _props.baseUrl,
            sectionsUrls = _props.sectionsUrls,
            visitorId = _props.visitorId,
            metaSiteId = _props.metaSiteId,
            locale = _props.locale,
            _props$host = _props.host,
            formFactor = _props$host.formFactor,
            style = _props$host.style;

        var getDeviceType = function getDeviceType(type) {
          return type === 'mobile' || type === 'tablet' ? 'mobile' : 'desktop';
        };
        this.wixSdk = (0, _wixSdkOOI2.default)({ baseUrl: baseUrl, sectionsUrls: sectionsUrls, visitorId: visitorId, metaSiteId: metaSiteId, locale: locale, deviceType: getDeviceType(formFactor.toLowerCase()), style: style });
      }
    }
  }, {
    key: 'getConsentPolicyQuery',
    value: function getConsentPolicyQuery(consentPolicy) {
      if (consentPolicy && consentPolicy.policy) {
        return encodeURIComponent((0, _stringify2.default)(consentPolicy));
      } else {
        return undefined;
      }
    }
  }, {
    key: 'getQueryParams',
    value: function getQueryParams() {
      var _props2 = this.props,
          consentPolicy = _props2.consentPolicy,
          queryParams = _props2.queryParams;

      var search = queryParams;
      var _consentPolicy = consentPolicy || queryParams.consentPolicy;
      if (_consentPolicy) {
        search.consentPolicy = this.getConsentPolicyQuery(_consentPolicy);
      }
      return search;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          connectedProviders = _props3.connectedProviders,
          host = _props3.host;

      if (!connectedProviders) {
        return null;
      }
      this.init();
      var height = this.state.height;

      var styles = height ? { height: height + 'px' } : {};
      return _react2.default.createElement(
        'div',
        { style: styles },
        _react2.default.createElement(_ProviderIntent2.default, {
          api: new _WixSDKProviderApi2.default(this.wixSdk),
          connectedProviders: connectedProviders,
          hiddenFromEditor: true,
          ref: function ref(element) {
            return _this2.intent = element;
          },
          viewMode: host.viewMode.toLowerCase(),
          intent: _consts.providerIntents.thankyou,
          onMessageReceived: function onMessageReceived(type, payload, resolve, reject, providerId) {
            return _this2.handleThankyouMessageReceived(type, payload, resolve, reject, providerId);
          },
          additionalParams: this.getQueryParams()
        })
      );
    }
  }]);
  return ThankyouIntentOOI;
}(_react.Component);

module.exports = ThankyouIntentOOI;